// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uweIE3WBWg08rGxmykdD{margin-bottom:23px}.CmOIqzaa5cHvRHuV9jWs{position:relative}.CmOIqzaa5cHvRHuV9jWs:before{background-color:var(--white-50);width:100%;height:100%;z-index:var(--zIndex-BASE_10);content:"";position:absolute;top:0;left:0}.Btqk1x2ipQvgMRy4uNo_{margin-bottom:10px}.Btqk1x2ipQvgMRy4uNo_:last-of-type{margin-bottom:0}.cFT62hPjtoY3mrCzeKH0{color:var(--content-primary-tertiary);margin-bottom:8px;padding:0 8px;font-size:12px;font-weight:500}.Ap05CahpuqI25wvyfTQb{max-height:150px;margin:0 -8px;overflow:auto}.g_dF2WxCJW0581IB1AZw{color:var(--content-primary-tertiary);justify-content:center;align-items:center;height:50px;margin-top:-10px;font-size:12px;font-weight:400;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search": `uweIE3WBWg08rGxmykdD`,
	"loading": `CmOIqzaa5cHvRHuV9jWs`,
	"content": `Btqk1x2ipQvgMRy4uNo_`,
	"content__title": `cFT62hPjtoY3mrCzeKH0`,
	"contentTitle": `cFT62hPjtoY3mrCzeKH0`,
	"scroll": `Ap05CahpuqI25wvyfTQb`,
	"isEmpty": `g_dF2WxCJW0581IB1AZw`
};
export default ___CSS_LOADER_EXPORT___;
